import { render, staticRenderFns } from "./OidcCallbackError.vue?vue&type=template&id=49d52666"
import script from "./OidcCallbackError.vue?vue&type=script&lang=js"
export * from "./OidcCallbackError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4.17.23_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports